<p-messages id="growl" [(value)]="_messageService.messages"></p-messages>

<p-confirmDialog acceptLabel="Sim" width="425" rejectLabel="Não" #cd>
  <footer>
    <button id="nao" type="button" pButton icon="fa-close" label="Não" (click)="cd.reject()"></button>
    <button id="sim" type="button" pButton icon="fa-check" label="Sim" (click)="cd.accept()"></button>
  </footer>
</p-confirmDialog>

<!--
BODY TAG OPTIONS:
=================
Apply one or more of the following classes to get the
desired effect
|---------------------------------------------------------|
| SKINS         | skin-blue (PADRAO)                      |
|               | skin-black (CRIADA)
|               | skin-blue-white (CRIADA)                |
|---------------------------------------------------------|
|LAYOUT OPTIONS | fixed                                   |
|               | layout-boxed                            |
|               | layout-top-nav                          |
|               | sidebar-collapse                        |
|               | sidebar-mini                            |
|---------------------------------------------------------|
-->

<!-- <body class="hold-transition skin-blue sidebar-mini"> -->
<!-- <div class="wrapper" >-->

<!-- Main Header  Cabecaçalho -->
<!-- 
<header class="main-header" *ngIf="authService.isLoggedIn">  
  <a href="#" class="logo">       
    <span class="logo-mini">      
      <img class="responsive-img" src="../assets/img/logo/icon/logo-icon.png">   
    </span>   
    <span class="logo-lg">
      <img class="responsive-img" src="../assets/img/logo/pequeno/logo.png">
    </span>
  </a>
    <nav class="navbar navbar-static-top" role="navigation">    
      <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button" (click)="toggleMenu()">
        <span class="sr-only">Toggle navigation</span>
      </a>    
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav" style="padding-top: 6px;">
          <li class="dropdown messages-menu">
            <a data-toggle="control-sidebar">
              {{ globalsVariablesService.nomeLoja}}
            </a>
          </li>
          <li class="dropdown messages-menu">
            <a href="https://api.whatsapp.com/send?phone=5562996360547&text=Enviando%20mensagem" target="_blank"
              style="cursor: pointer">
              <i class="fa fa-whatsapp" style="font-size: 21px;"></i></a>
          </li>

          <li *ngIf="globalsVariablesService.isRepresentante" class="dropdown messages-menu">
            <a routerLink="/administrativo/representante">
              <i class="fi-dashboard-opening-email"></i>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.isRepresentante" class="dropdown messages-menu">
            <a routerLink="/administrativo/boleto-cliente">
              <i class="fi-dashboard-dashboard"></i>
            </a>
          </li>

          <li>
            <a (click)="logout()" data-toggle="control-sidebar">
              <i class="fa fa-power-off"></i>
            </a>
          </li>
        </ul>
      </div>
    </nav>
</header>
 -->
<!-- Left side column. contains the logo and sidebar -->

<aside id="menuLateral" *ngIf="authService.isLoggedIn" [ngClass]="toggleIsOpen ? 'menuLateralAberto' : 'menuLateralFechado'">
  
  <div style="padding: 10px;margin-bottom: 29px;" >
    <a class="sidebar-toggle" data-toggle="push-menu" role="button"  style="font-size: 20px;" (click)="toggleMenu()">
      <span ><i class="fa fa-bars" aria-hidden="true"></i>
      </span>
    </a>
    <a class="logo" style="margin-left: 25px;" *ngIf="toggleIsOpen">
      <span class="logo-lg" >
        <!-- <img class="responsive-img" src="../assets/img/logo/pequeno/logo.png"> -->
        <!-- <img class="responsive-img" [src]="secondaryLogo"> -->
         <img class="responsive-img" src="../assets/img/logo/pequeno/logo.png"> 
      </span>
    </a>

    <!-- <span style="background-color:#071c4d; height: 100px;" >
      <h5 style=" background-color: #071c4d; color: white;">  {{ globalsVariablesService.nomeLoja}} </h5>
    </span>   -->
 </div>

    

  <!-- sidebar: style can be found in sidebar.less -->
  <section>


    <!-- Sidebar user panel (optional) -->
    <div class="subMenuTitulo" (click)="fecharSubMenu()" *ngIf="(subMenuAberto && toggleIsOpen)">
       <span> ⇦ </span> <span> {{subMenuTitulo}}</span>
     </div>       

     <!--
        <div class="pull-left image">
          <img src="{{globalsVariablesService.getUsuarioLogado.caminhoImagem}}" class="img-circle" alt="User Image">
        </div>
        <div class="pull-left info">
          <p><span>Olá</span>,<br>{{globalsVariablesService.getUsuarioLogado.pessoaNomeFantasia}}</p>
          
          <a href="#">
            <i class="fa fa-circle text-success"></i> Online</a>
        </div>
        </div>
      -->

    <!-- search form (Optional)
      <form action="#" method="get" class="menu-search sidebar-form">
        <div class="input-group">        
        </div>
      </form> 
    -->
    <!-- /.search form -->

    <!-- Sidebar Menu -->        
    
    <ul [ngClass]="subMenuAberto ? 'menuFechado' : 'menuAberto'">

      <li class="subMenuItem" (click)=" onClickDashboard();">
        <a  routerLink="/dashboard" >
          <i class="rota fi-dashboard-graphic" style="display: inline;"></i>
          <span *ngIf="!subMenuAberto"> Dashboard </span>
        </a>
      </li>

      <li class="subMenuItem" (click)="abrirSubMenu('cadastros', 'Cadastros', 2)">
        <a>
          <i class="fi-dashboard-rounded-paper-with-text-lines-and-one-folded-corner"></i>
          <span *ngIf="!subMenuAberto">Cadastros</span>
        </a>

        <ul  [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'"  *ngIf="subMenuAberto == 'cadastros'" >
          <li>
            <a routerLink="/cadastros/loja">
              <span class="rota icon"> Empresa </span>
            </a>
          </li>
          <li>
            <a routerLink="/cadastros/materia-prima">
              <span class="rota icon"> Materia Prima</span>
            </a>
          </li>
          <li>
            <a routerLink="/cadastros/tecnico">
              <span class="rota icon"> Tecnico</span>
            </a>
          </li>
          <li>
            <a routerLink="/cadastros/processo-fase">
              <span class="rota icon"> Processo Fase</span>
            </a>
          </li>
        </ul>
      </li>

      <li class="subMenuItem" (click)="abrirSubMenu('seguranca', 'Segurança', 3)">
        <a>
          <i class="fi-ecommerce-padlock"></i>
          <span *ngIf="!subMenuAberto">Segurança</span>
        </a>
        
        <ul [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'"  *ngIf="subMenuAberto == 'seguranca'">
          <li *ngIf="globalsVariablesService.getPermissoes.visualizarGrupoLoja" >
            <a class="rota" routerLink="/seguranca/grupo-loja">
              <span class="rota icon">Grupo Loja </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.getPermissoes.visualizarPermissao">
            <a class="rota" routerLink="/seguranca/permissao">
              <span class="rota icon">
                <i class="rota fa fa-circle-o"></i> Permissões </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.getPermissoes.visualizarUsuario">
            <a class="rota" routerLink="/seguranca/usuario">
              <span class="rota icon"> Usuário </span>
            </a>
          </li>

          <li>
            <a class="rota" routerLink="/seguranca/trocar-senha">
              <span class="rota icon"> Trocar Senha </span>
            </a>
          </li>

        </ul>
      </li>
      <li  class="subMenuItem" (click)="abrirSubMenu('financeiro', 'PCP', 4)">
        <a>
          <i class="fi-ecommerce-money"></i>
          <span *ngIf="!subMenuAberto">PCP</span>          
        </a>

        <ul [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'" *ngIf="subMenuAberto == 'financeiro'">

          <li>
            <a class="rota" routerLink="/pcp/pedido-pcp">
              <span class="rota icon">Visão PCP </span>
            </a>
          </li>
          <li>
            <a class="rota" routerLink="/pcp/pcp-fase-tecnico">
              <span class="rota icon">Apontamento Técnico</span>
            </a>
          </li>
          <li>
            <a class="rota" routerLink="/pcp/pcp-gestao">
              <span class="rota icon">Gestão PCP</span>
            </a>
          </li>
        </ul>
      </li>

      <li class="subMenuItem" (click)="abrirSubMenu('relatorios', 'Relatórios', 5)">
        <a>
          <i class="fi-dashboard-rounded-paper-with-text-lines-and-one-folded-corner"></i>
          <span *ngIf="!subMenuAberto">Relatórios</span>
        </a>
       <ul [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'" *ngIf="subMenuAberto == 'relatorios'">
   
          <li>
            <a class="rota" routerLink="/relatorios/rel-pcp">
              <span class="rota icon"> PCP </span>
            </a>
          </li>

          <!-- *ngIf="globalsVariablesService.getPermissoes.visualizarRelatorioDuplicatasPagar" -->
          <!-- <li *ngIf="false">
            <a class="rota" routerLink="/relatorios/rel-lanc-financeiro">
              <span class="rota icon">Lançamentos Financeiro </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.getPermissoes.visualizarRelatorioConciliacao">
            <a class="rota" routerLink="/relatorios/rel-conciliacao">
              <span class="rota icon">Conc. Pagar/Receber </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.getPermissoes.visualizarRelatorioProdutoEntradaSaida">
            <a class="rota" routerLink="/relatorios/rel-produto-entrada-saida">
              <span class="rota icon">Produtos Entrada/Saida </span>
            </a>
          </li> -->

          <!-- <li>
            <a class="rota" routerLink="/relatorios/rel-movimentacao-plano-contas">
              <span class="rota icon">Movimentação Plano de Contas</span>
            </a>
          </li> -->
  
        </ul>
      </li>

      <!-- <li class="subMenuItem" (click)="abrirSubMenu('menuFiscalSC', 'Menu Fiscal', 8)">
        <a>
          <i class="fi-dashboard-rounded-paper-with-text-lines-and-one-folded-corner"></i>
          <span *ngIf="!subMenuAberto">Menu Fiscal</span>
        </a>
        <ul  [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'"  *ngIf="subMenuAberto == 'menuFiscalSC'">
          <li>
            <a class="rota" routerLink="/paf-nfce/identificacao-software">
              <span class="rota icon">Dados Software House </span>
            </a>
          </li>

          <li>
            <a class="rota" routerLink="/paf-nfce/gerar-paf-nfce">
              <span class="rota icon">   Gerar Arquivo PAF NFCe </span>
            </a>
          </li>
  
        </ul> 
      </li> -->

      <li class="subMenuItem" style="padding-left: 15px;" (click)="logout()">
        <a>
          <i class="fa fa-power-off"></i>
          <span >Sair</span>
        </a>
    </li>   

    

   

    </ul>
    <div *ngIf="globalsVariablesService.isRepresentante" style="left: 50px; bottom: 10px; position: fixed;">
      <a routerLink="/administrativo/representante">
        <i class="fa fa-users" style="font-size: 35px;"></i>
      </a>  
    </div>
    
    <div style="left: 5px; bottom: 10px; position: fixed;">
      <a [href]="getWhatsappUrl()" target="_blank" style="cursor: pointer">
        <i class="fa fa-whatsapp" style="font-size: 35px;"></i>
      </a>
    </div>
    <!-- /.sidebar-menu -->
  </section>
  <!-- /.sidebar -->
</aside>

<!-- Content Wrapper. Contains page content -->
<div id="container-principal" [ngClass]="{'container-mr7': authService.isLoggedIn}">
  <!-- Content Header (Page header) -->
  <!--
          <section class="content-header">
            <h1>
              Page Header
              <small>Optional description</small>
            </h1>
            <ol class="breadcrumb">
              <li><a href="#"><i class="fa fa-dashboard"></i> Level</a></li>
              <li class="active">Here</li>
            </ol>
          </section> -->

  <!-- Main content -->
  <section class="content">

    <router-outlet>

    </router-outlet>

  </section>
  <!-- /.content -->
</div>
<!-- /.content-wrapper -->

<!-- Main Footer -
    <footer class="main-footer" *ngIf="authService.isLoggedIn" >

      <div class="pull-right hidden-xs">
        ..
      </div>
      <!-- Default to the left
      <strong>Copyright &copy; 2016 <a href="#">MR7 TI</a>.</strong>todos os direitos reservados.

    </footer>  -->

<!-- /.control-sidebar -->
<!-- Add the sidebar's background. This div must be placed
       immediately after the control sidebar -->

<div class="control-sidebar-bg" *ngIf="authService.isLoggedIn"></div>

<!-- </div> ./wrapper -->

<!-- REQUIRED JS SCRIPTS -->

<!-- jQuery 2.2.0 -->
<!-- Optionally, you can add Slimscroll and FastClick plugins.
     Both of these plugins are recommended to enhance the
     user experience. Slimscroll is required when using the
     fixed layout. -->
<!--</body> -->
